import React from 'react'
import styled from '@emotion/styled'

import {Box} from '@vio/atlas/helpers/Box'
import {SkeletonLoader} from '@vio/atlas/SkeletonLoader'
import {cssTheme} from '@vio/atlas/themes'

import {OfferLayoutBaseProps, OfferLayoutLoadingProps} from '.'
import {useCashbackPositioning} from './useCashbackPositioning'

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${cssTheme.layout.spacing.s300} ${cssTheme.layout.spacing.s400};
  min-height: 52px;
`

const RightInnerWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  flex-direction: column;
`

export const RightWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-left: ${cssTheme.layout.spacing.s300};
`

type Props = Omit<OfferLayoutBaseProps, 'tagComponent'>

export const SecondaryDefaultLayout: React.FC<
  Props | OfferLayoutLoadingProps
> = ({
  isLoading,
  priceComponent,
  providerLogoComponent,
  roomLabelsComponent,
  ctaComponent,
  cashbackComponent,
  className,
  dataId
}) => {
  const {showCashbackOnLeft, showCashbackOnRight} = useCashbackPositioning({
    cashbackComponent
  })

  if (isLoading)
    return (
      <Wrapper>
        <SkeletonLoader width={139} marginTop={0} />
        <SkeletonLoader width={56} marginTop={0} align="right" />
      </Wrapper>
    )

  return (
    <Wrapper className={className} data-id={dataId}>
      <div>
        {providerLogoComponent}
        <Box display="flex" gap="s200" flexWrap="wrap">
          {roomLabelsComponent}
          {showCashbackOnLeft}
        </Box>
      </div>
      <RightWrapper>
        <RightInnerWrapper>
          {priceComponent}
          {showCashbackOnRight}
        </RightInnerWrapper>
        {ctaComponent}
      </RightWrapper>
    </Wrapper>
  )
}
